document.addEventListener("DOMContentLoaded", () => {
	// location.hash = '';

	const addNotesList = document.querySelectorAll('.js-new-note');
// Функция для отправки данных на сервер
	const saveNote = (diagnosisId, note) => {
		if (!note) return;

		BX.ajax.runComponentAction('main:diagnosis', 'commentsList', {
			mode: 'ajax',
			data: { diagnosis_id: diagnosisId, note: note }
		})
			.then((response) => {
				if (response.data) console.log(response.data);
			})
			.catch((error) => {
				console.error(error);
			});
	};

// Основная логика обработки клика
	addNotesList.forEach(element => {
		element.addEventListener('click', (e) => {
			const toEdit = e.target.nextElementSibling;
			if (!toEdit) return;

			// Создаем textarea для редактирования
			const textarea = document.createElement('textarea');
			textarea.className = 'note-editor editable';
			const initialValue = toEdit.textContent.trim();
			textarea.value = initialValue;
			textarea.dataset.oldValue = initialValue;

			toEdit.textContent = '';
			toEdit.appendChild(textarea);
			textarea.focus();

			// Обработчик потери фокуса
			const handleBlur = () => {
				const updatedValue = textarea.value.trim();
				toEdit.textContent = updatedValue;

				if (updatedValue !== textarea.dataset.oldValue) {
					const diagnosisId = toEdit.dataset['diagnosisId'];
					saveNote(diagnosisId, updatedValue);
				}

				cleanup();
			};

			// Обработчик нажатия клавиш
			const handleKeydown = (e) => {
				if (e.key === 'Enter') {
					e.preventDefault(); // Предотвращаем добавление новой строки
					textarea.blur();
				} else if (e.key === 'Escape') {
					e.preventDefault();
					toEdit.textContent = textarea.dataset.oldValue; // Восстанавливаем старое значение
					cleanup();
				}
			};

			// Функция для удаления обработчиков и элементов
			const cleanup = () => {
				textarea.removeEventListener('blur', handleBlur);
				textarea.removeEventListener('keydown', handleKeydown);
				textarea.remove();
			};

			// Назначаем обработчики
			textarea.addEventListener('blur', handleBlur);
			textarea.addEventListener('keydown', handleKeydown);
		});
	});

	document.addEventListener('click', (event) => {
		// Проверяем, клик произошел по элементу внутри .quantity
		const quantityWrapper = event.target.closest('.quantity');
		if (!quantityWrapper) return;

		const quantityInput = quantityWrapper.querySelector('input');

		if (event.target.classList.contains('fa-minus')) {
			const currentValue = parseInt(quantityInput.value, 10) || 1; // Убеждаемся, что значение — число
			quantityInput.value = Math.max(1, currentValue - 1); // Не допускаем значения меньше 1
		}

		if (event.target.classList.contains('fa-plus')) {
			const currentValue = parseInt(quantityInput.value, 10) || 1;
			quantityInput.value = currentValue + 1;
		}
	});
	const form = document.querySelector('form#xxx'),
		  finalComment = document.getElementById('final-comment');

	if (form && finalComment) {
		form.addEventListener('submit', function (event) {
			if (!finalComment.value.trim()) {
				event.preventDefault();
				alert('Пожалуйста, оставьте комментарий перед отправкой.');
			}
		});
	}
});
